// engine
import { ArContainer, ArText } from '@aceroll/core';

export class BtnContinue extends ArContainer {
    constructor() {
        super('continue-btn');

        const text = ArText.from('click_to_continue_uc', 'splashContinueLabel', 'Continiue Button');
        text.anchor.set(0.5, 0.5);
        text.position.set(0, -2);

        this.addChild(text);
    }
}